<template>
    <div>
        <button class="btn btn-block btn-primary" v-if="isVisible" @click="openModal()">
            {{ "ShoppingWizard::Template.widgetButtonLabel" | translate }}
        </button>
    </div>
</template>

<!--suppress EqualityComparisonWithCoercionJS -->
<script>
    import ModalService from "../services/ModalService";
    import {EventBus} from "../event-bus";

    export default {
        props: {
            configuration: Object
        },
        inject: {
            itemId: {
                default: null
            }
        },
        computed: {
            itemData() {
                if(this.itemId){
                    return this.$store.getters[`${this.itemId}/currentItemVariation`];
                }
                return {};
            },
            isVisible() {
                for (let property of this.itemData.properties) {
                    if (property.group) {
                        if (
                            property.group.id == this.configuration.groupIdBranding ||
                            property.group.id == this.configuration.groupIdAirbrush
                        ) {
                            return true;
                        }
                    }
                }
                return false;
            }

        },
        data() {
            return {
            }
        },
        mounted() {
            //console.log('itemId is', this.itemId);
        },
        methods: {
            openModal() {
                EventBus.$emit('openWizardModal', this.itemId);
            },
            hasPropertyGroupActive(propertyGroupId) {
                for (let property of this.itemData.properties) {
                    if (property.group) {
                        if (property.group.id == propertyGroupId) {
                            return true;
                        }
                    }
                }
                return false;
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ShoppingWizardButton.vue